<template>
  <v-card>
    <v-btn @click="$emit('close')" absolute right class="mt-3" icon>
      <v-icon>fas fa-times</v-icon>
    </v-btn>
    <v-btn class="mr-12 mt-3" style="min-width: auto" absolute right color="primary" small @click="print">
      <v-icon>fas fa-print</v-icon>
    </v-btn>
    <v-card-text id="infoTaxUserWrap">
      <v-card-title><h4 style="word-break: normal; padding-right: 65px">Информация по физическим лицам</h4></v-card-title>
      <column-table v-if="userData" :data="userData" :rows="userDebtHeaders"/>
    </v-card-text>
  </v-card>
</template>

<script>
import ColumnTable from "@/components/ui/table/ColumnTable";
import printTaxInfoMixin from "@/components/calculation/calculator-tax/printTaxInfoMixin";

export default {
  name: 'InfoTax',
  props: {
    userData: {
      type: Object
    }
  },
  data() {
    return {
      userDebtHeaders: [
        {
          text: 'Область',
          value: 'ns10_code'
        },
        {
          text: 'Район',
          value: 'ns11_code'
        },
        {
          text: 'ИНН',
          value: 'tin'
        },
        {
          text: 'Наименование Физ. Лица',
          value: 'company_name'
        },
        {
          text: 'Адрес',
          value: 'adress'
        },
        {
          text: 'Серия паспорта',
          value: 'series_passport'
        },
        {
          text: 'Номер паспорта',
          value: 'number_passport'
        },
        {
          text: 'Кем выдан паспорт',
          value: 'org_passport'
        }
      ]
    }
  },
  components: {ColumnTable},
  mixins: [printTaxInfoMixin('infoTaxUserWrap')]
}
</script>